module.exports = __webpack_public_path__ + "img/facebook.d50ea0b4.png";